<div [id]="model.id"
     class="item-content"
     [class.is-disabled]="this.isDisabled">
  <div class="tableContent">
  <span class="task-icon">
    <mat-icon *ngIf="this.isStopped">
      done
    </mat-icon>
    <mat-icon *ngIf="this.isActive">
      timer_outlined
    </mat-icon>
    <mat-icon *ngIf="this.isPaused">
      pause
    </mat-icon>
  </span>
  <span class="task-name">{{this.name}}</span>
  <span class="assignees">{{this.assignees}}</span>
  <span class="task-actions" *ngIf="!this.isDisabled">
    <ng-container *ngIf="this.isBusy; else notBusy">
      <span class="busy-container">
        <mat-spinner diameter="24"></mat-spinner>
      </span>
    </ng-container>
    <ng-template #notBusy>
      <span *ngIf="this.isErrored"
            class="action-error">
        Operation failed. Please try again.
      </span>
      <button type="button"
              *ngIf="this.canStart"
              class="start"
              (click)="this.start()"
              aria-label="Start Task"
              mat-stroked-button>
        <mat-icon>timer_outlined</mat-icon>
        START
      </button>
      <button type="button"
              *ngIf="this.canPause"
              class="pause"
              (click)="this.pause()"
              aria-label="Pause Task"
              mat-stroked-button>
        <mat-icon>pause</mat-icon>
        PAUSE
      </button>
      <button type="button"
              *ngIf="this.canResume"
              class="resume"
              (click)="this.resume()"
              aria-label="Resume Task"
              mat-stroked-button>
        <mat-icon>play_arrow</mat-icon>
        RESUME
      </button>
      <button type="button"
              *ngIf="this.canStop"
              class="finish"
              (click)="this.stop()"
              aria-label="Finish Task"
              mat-stroked-button>
        <mat-icon>done</mat-icon>
        FINISH
      </button>
      <button type="button"
              *ngIf="this.canRestart"
              class="restart"
              (click)="this.restart()"
              aria-label="Restart Task"
              mat-stroked-button>
        <mat-icon>more_time</mat-icon>
        RESTART
      </button>
    </ng-template>
  </span>
</div>
</div>